import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { COMPLIANCE_SUMMARY_TAB_KEY } from "../redux/reducers/complianceSummaryReducer";
import { store } from "@store";
import useOrganisationTree from "./useOrganisationTree";

export default function useComplianceView() {
  const data = useSelector((state) => state.complianceSummaryTab);
  const dispatch = useDispatch();

  const { onOrgTreeSelectionChange } = useOrganisationTree();

  const { activeIndex, eventsGridLoading, filtersLoading } = data;
  const {
    hasSelection,
    filterSelected: { operator, company, site, subcompany },
  } = useSelector((state) => state.complianceFilters);

  const onOrgTreeChange = () => onOrgTreeSelectionChange(operator, company);

  const setViewData = (payload) => {
    dispatch({ type: COMPLIANCE_SUMMARY_TAB_KEY, payload });
  };

  const onTabChange = useCallback(
    (_e, { activeIndex }) => {
      setViewData({ activeIndex });
      const showOrgTree = activeIndex === 0;
      store.dispatch(async (dispatch) =>
        dispatch({
          type: "FETCH_COMPLIANCE_FILTERS",
          payload: { showOrgTree },
        }),
      );
    },
    [setViewData, store],
  );

  const isLoading =
    eventsGridLoading || filtersLoading; /* graphLoading || gridLoading  || */

  return {
    ...data,
    operator,
    companyId: company.id,
    subcompanyId: subcompany.id,
    siteId: site.id,
    onOrgTreeChange,
    onTabChange,
    isLoading,
    activeIndex,
    hasSelection,
    setViewData,
  };
}
